import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import studentgirlImgSrc from "../../../../image/home/student-girl.png";

import {
  Heading,
  InfoSecImg,
  ListImgWrapper,
  ListItemContent,
  StlyedSection,
} from "./styledInfoSection";

const InfoSectionComponent = ({ content }) => {
  return (
    <StlyedSection>
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <InfoSecImg
              src={studentgirlImgSrc}
              alt="دانش‌آموز"
              width="360"
              className="d-block mx-auto img-fluid"
            />
          </Col>
          <Col xs={12} md={6}>
            <Heading className="my-5">
              یادگیری آسان با
              <strong>
                <span> آز</span>
                <span>تو</span>
              </strong>
            </Heading>
            <ul className="list-unstyled">
              {content.map((item) => {
                return (
                  <li
                    key={item.id}
                    className="d-flex justify-content-center mb-2 mb-md-4"
                  >
                    <ListImgWrapper className="d-flex position-relative pt-3">
                      <img
                        src={item.img}
                        alt={item.title}
                        width={item.imgWidth}
                        height={item.imgHeight ? item.imgHeight : "49"}
                        className={item.className}
                      />
                    </ListImgWrapper>
                    <ListItemContent>
                      <h5>{item.title}</h5>
                      <p>{item.text}</p>
                    </ListItemContent>
                  </li>
                );
              })}
            </ul>
          </Col>
        </Row>
      </Container>
    </StlyedSection>
  );
};

export default InfoSectionComponent;
